<form
  [formGroup]="e911FormGroup"
  (ngSubmit)="save()"
  name="admin-e911-location-edit"
  id="admin-e911-location-edit"
  onsipFormTracking
>
  @if (hasApiError) {
  <mat-error class="e911-api-error">
    <mat-icon>error</mat-icon>
    <span class="mat-body-2">
      {{
        "ONSIP_I18N.E911_EMERGENCY_RESPONSE_LOCATION_COULD_NOT_BE_ADDED_THERE_WERE_ISSUES_VERIFYING_FIELDS_HIGHLIGHTED_IN_RED"
          | translate
      }}
      <span class="contact-support" [routerLink]="views.CONTACT_SUPPORT">{{
        "ONSIP_I18N.CONTACT_OUR_SUPPORT_TEAM" | translate
      }}</span>
      {{ "ONSIP_I18N.IF_FURTHER_ASSISTANCE_IS_REQUIRED" | translate }}
    </span>
  </mat-error>
  } @if ((isMediumView | async) === false) {
  <div class="mat-body-1 m-b-12 p-l-16">
    {{ "ONSIP_I18N.E911_EMERGENCY_RESPONSE_LOCATION" | translate }}
  </div>
  }
  <div onsip-grid-placement-shelf>
    <div class="first-column">
      @if (isMediumView | async) {
      <div class="mat-body-1 m-b-12">
        {{ "ONSIP_I18N.E911_EMERGENCY_RESPONSE_LOCATION" | translate }}
      </div>
      }
      <section class="with-mat-form-field">
        <mat-form-field class="edit-location-name" appearance="outline">
          <mat-label>{{ "ONSIP_I18N.LOCATION_NAME" | translate }}</mat-label>
          <input matInput required autocomplete="off" formControlName="name" />
          <mat-error>{{
            getGenericNameError(
              this.e911FormGroup.controls.name,
              "ONSIP_I18N.LOCATION_NAME" | translate
            )
          }}</mat-error>
        </mat-form-field>
      </section>
      <section class="with-mat-form-field">
        <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.TYPE" | translate }}</div>
        <mat-form-field class="edit-address-type" appearance="outline">
          <mat-select formControlName="secondaryAddressType">
            @for (type of addressTypesArray; track type) {
            <mat-option [value]="type">
              {{ type }}
            </mat-option>
            }
          </mat-select>
          <mat-hint>{{ "ONSIP_I18N.EG_FLOOR_SUITE_BUILDING_ETC" | translate }}</mat-hint>
        </mat-form-field>
      </section>
      <section class="with-mat-form-field">
        <mat-form-field class="edit-address-city" appearance="outline">
          <mat-label>{{ "ONSIP_I18N.CITY" | translate }}</mat-label>
          <input matInput required formControlName="city" />
          <mat-error>{{ getCityError() }}</mat-error>
        </mat-form-field>
      </section>
      <section>
        <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.COUNTRY" | translate | sentenceCase }}</div>
        <div class="mat-body-2">
          {{
            e911Location.country === "US"
              ? ("ONSIP_I18N.UNITED_STATES_OF_AMERICA" | translate)
              : e911Location.country
          }}
        </div>
      </section>
    </div>
    <div class="second-column">
      <section class="with-mat-form-field">
        <mat-form-field class="edit-address" appearance="outline">
          <mat-label>{{ "ONSIP_I18N.ADDRESS" | translate }}</mat-label>
          <input matInput required formControlName="address" />
          <mat-error>{{ getAddressError() }}</mat-error>
        </mat-form-field>
      </section>
      <section class="with-mat-form-field">
        <mat-form-field class="edit-address-number" appearance="outline">
          <mat-label>{{ "ONSIP_I18N.UNIT_NUMBER_OR_DESCRIPTION_OPTIONAL" | translate }}</mat-label>
          <input matInput autocomplete="off" formControlName="secondaryAddressNumber" />
          <mat-hint>{{ "ONSIP_I18N.PINPOINT_YOUR_EXACT_LOCATION" | translate }}</mat-hint>
          <mat-error>{{
            getGenericNameError(
              this.e911FormGroup.controls.secondaryAddressNumber,
              "ONSIP_I18N.ADDRESS_NUMBER" | translate
            )
          }}</mat-error>
        </mat-form-field>
      </section>
      <section class="with-mat-form-field">
        <div class="e911-location-sz">
          <mat-form-field class="edit-address-state" appearance="outline">
            <!-- HACK for autocompleting state form field -->
            <input
              class="hide-for-autocomplete"
              type="text"
              name="state"
              [formControl]="autoCompleteState"
              autocomplete="address-level1"
            />
            <mat-label>{{ "ONSIP_I18N.STATE" | translate }}</mat-label>
            <mat-select required formControlName="state">
              @for (state of listOfStates; track state) {
              <mat-option [value]="state[1]">
                {{ state[1] }}
              </mat-option>
              }
            </mat-select>
            <mat-error>{{ getStateError() }}</mat-error>
          </mat-form-field>
          <mat-form-field class="edit-address-zipcode" appearance="outline">
            <mat-label>{{ "ONSIP_I18N.POSTAL_CODE" | translate }}</mat-label>
            <input matInput required maxlength="10" formControlName="zipcode" />
            <mat-error>{{ getPostalCodeError() }}</mat-error>
          </mat-form-field>
        </div>
      </section>
      <section>
        <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.ADDRESS_TYPE" | translate }}</div>
        <div class="mat-body-2">{{ e911Location.locationType }}</div>
      </section>
      <section class="with-mat-form-field">
        @if ((isMediumView | async) === false) {
        <mat-form-field class="e911-notification-email" appearance="outline">
          <mat-label>{{ "ONSIP_I18N.NOTIFICATION_EMAIL_ADDRESS" | translate }}</mat-label>
          <input matInput autocomplete="off" formControlName="email" />
          <mat-hint>{{
            "ONSIP_I18N.DIALING_911_WILL_TRIGGER_A_NOTIFICATION_TO_THIS_ADDRESS" | translate
          }}</mat-hint>
          <mat-error>{{ "ONSIP_I18N.MUST_BE_A_VALID_EMAIL_ADDRESS" | translate }}</mat-error>
        </mat-form-field>
        }
      </section>
    </div>
    <div class="third-column">
      <section class="with-mat-form-field" formGroupName="additionalParams">
        <div class="mat-body-1 m-b-12">
          {{ "ONSIP_I18N.ASSIGNED_USERS" | translate }} ({{
            additionalParams.controls.assignedUsers.value.length
          }})
        </div>
        <mat-form-field appearance="outline" class="assigned-users">
          <onsip-selection-list-deluxe
            disableRipple
            color="primary"
            formControlName="assignedUsers"
            [showSearchField]="e911Location.locationType !== locationPrivate"
            [showMasterToggle]="e911Location.locationType !== locationPrivate"
          >
            @for (user of userE911InfoArray; track user) {
            <mat-list-option checkboxPosition="before" [value]="user">
              {{ user.name }}
            </mat-list-option>
            }
          </onsip-selection-list-deluxe>
        </mat-form-field>
      </section>
    </div>
  </div>
  <div class="page-view-controls">
    <button mat-button class="toggle-button" type="button" (click)="togglePanel()" color="primary">
      {{ "ONSIP_I18N.CANCEL" | translate }}
    </button>
    <button mat-flat-button class="toggle-button" type="submit" color="primary">
      {{ "ONSIP_I18N.SAVE_CHANGES" | translate }}
    </button>
  </div>
</form>
